import { useState, useEffect } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const sessionsService = {
  _url: process.env.REACT_APP_SESSIONS_API_URL,

  GetSessionsList(searchQuery, fetch) {
    const [sessionsData, setSessionsData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getSessionsList(searchQuery))
        .then(res => {
          setSessionsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      sessions_loading: status === STATUS.LOADING,
      sessions_error: status === STATUS.ERROR,
      sessions_data: sessionsData,
    };
  },

  GetSessionHistory(searchQuery, fetch) {
    const [sessionsData, setSessionsData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getSessionHistory(searchQuery))
        .then(res => {
          setSessionsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      sessions_loading: status === STATUS.LOADING,
      sessions_error: status === STATUS.ERROR,
      sessions_data: sessionsData,
    };
  },

  async getSessionsList(searchQuery) {
    return await Fetch.get(
      `${this._url}s/list?platform_id=${searchQuery?.platform_id}&project_id=${searchQuery?.project_id}&agent_id=${searchQuery?.agent_id}`,
    );
  },

  async getSessionHistory(searchQuery) {
    return await Fetch.get(`${this._url}/history?&session_id=${searchQuery?.session_id}`);
  },

  async createSession(payload) {
    return await Fetch.post(`${this._url}/create`, payload);
  },

  async deleteSession({ platform_id = '', session_id = '', user_id = '', agent_id = '', project_id = '' }) {
    return await Fetch.delete(
      `${this._url}/delete?platform_id=${platform_id}&session_id=${session_id}&user_id=${user_id}&agent_id=${agent_id}&project_id=${project_id}`,
    );
  },

  async updateSession(payload) {
    return await Fetch.put(`${this._url}/update`, payload);
  },
};

export default sessionsService;
